
















































































































































































import Vue from 'vue';
import { Editor, EditorContent, VueRenderer } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import Mention from '@tiptap/extension-mention';
import CommunityCommentMentionList from '@/web/components/community/CommunityCommentMentionList';
import tippy from 'tippy.js';
import CommunityMention from '@/web/components/community/community-mention';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import _ from 'lodash';
import { VEmojiPicker } from 'v-emoji-picker';
import GiphyComponent from '@/web/components/community/GiphyComponent';
import Image from '@tiptap/extension-image';
import HardBreak from '@tiptap/extension-hard-break';
import Code from '@tiptap/extension-code';
import CodeBlock from '@tiptap/extension-code-block';
import Blockquote from '@tiptap/extension-blockquote';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import ListItem from '@tiptap/extension-list-item';
import Link from '@tiptap/extension-link';
import CommunityCommentUploadImageModal from '@/web/views/admin/community/CommunityCommentUploadImageModal';
import parseUrls from '@/web/utils/parse-urls';
import auth from '@/core/api/modules/auth';
import AudioRecordingModal from '@/web/components/community/AudioRecordingModal';
import { uploadFileToS3 } from '@/web/services/upload';
import axios from 'axios';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import CommunityScheduleModal from '@/web/components/community/CommunityScheduleModal';
import moment from 'moment';

export default Vue.extend({
  name: 'CommunityCompose',
  components: {
    EditorContent,
    VEmojiPicker,
    GiphyComponent,
  },
  props: {
    type: {
      type: String,
      default: 'post',
    },
    user: {
      type: Object as () => CommunityProfileResponse,
      default: null,
      required: false,
    },
    id: {
      type: String,
      default: null,
    },
    numberId: {
      type: Number,
      default: null,
    },
    parentId: {
      type: Number,
      default: null,
    },
    buttonTitle: {
      type: String,
      default: 'COMMUNITY.BUTTON.POST_COMMENT',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    editText: {
      type: String,
    },
    attachmentProp: {
      type: Object,
    },
    hashtagsEnabled: {
      type: Boolean,
    },
    hashtags: {
      type: Array,
    },
    allowScheduling: {
      type: Boolean,
      default: false,
    },
    releaseOnProp: {
      type: Date,
    },
    initialHashtag: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      editor: null,
      buttonText: this.buttonTitle,
      dismissedUrls: [],
      attachment: this.attachmentProp || {},
      isAttachmentLoading: false,
      cancelSource: false,
      hashtag: null,
      releaseOn: this.releaseOnProp || null,
      isPosting: false,
    };
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacher: 'user/teacher',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    hasAttachment() {
      return this.attachment?.attachment_type != null;
    },
    api() {
      return {
        uploadFileToS3,
      };
    },
    hashtagTitle() {
      if (!this.hashtag) {
        return this.$t('COMMUNITY.LABEL.ADD_HASHTAG');
      }
      return this.hashtag;
    },
    editorJson() {
      return this.editor.getJSON();
    },
    canEditGroupPermissions() {
      return this.teacher && this.teacherStudioUrl === this.studio?.studio_url;
    },
  },
  methods: {
    schedulePost() {
      console.log('schedule...');
      this.$modal.show(CommunityScheduleModal, {
        releaseOn: this.releaseOn,
        openPicker: true,
        confirmFn: date => {
          console.log('confirmed date: ', date);
          this.releaseOn = date;
        },
      });
    },
    post() {
      this.isPosting = true;
      const json = this.editor.getJSON();
      const html = this.editor.getHTML();
      const text = html.replace(/<[^>]*>?/gm, '');
      const commentPayload: any = { json, text, html };
      if (this.parentId) {
        commentPayload.parentId = this.parentId;
      }
      if (this.releaseOn && moment(this.releaseOn).isAfter(moment())) {
        commentPayload.releaseOn = this.releaseOn;
      } else {
        commentPayload.releaseOn = null;
      }
      commentPayload.successFn = () => {
        this.editor.commands.clearContent();
        this.dismissedUrls = [];
        this.releaseOn = null;
        this.isPosting = false;
        this.cleanAttachment();
      };
      commentPayload.errorFn = () => {
        this.isPosting = false;
      };
      commentPayload.attachment = JSON.parse(JSON.stringify(this.attachment));
      commentPayload.hashtag = this.hashtag;

      if (this.editText) {
        commentPayload.id = this.numberId;
        this.buttonText = 'COMMUNITY.BUTTON.EDIT_COMMENT';
        this.$emit('editComment', commentPayload);
      } else {
        this.$emit('addComment', commentPayload);
      }
    },
    searchUsers: _.throttle(async function (query: string) {
      if (!query || query.length < 1) return [];

      return await this.$store.dispatch('community/searchUsers', {
        studioURL: this.studioURL,
        query,
      });
    }, 500),
    selectEmoji(emoji) {
      this.editor
        .chain()
        .focus()
        .insertContent(emoji.data + '<i></i>')
        .run();
    },
    addGiphyToComment(giphy) {
      if (giphy) {
        this.editor
          .chain()
          .focus()
          .insertContent('<i></i>')
          .setImage({ src: giphy })
          .run();
      }
    },
    openUploadImageModal() {
      this.$modal.show(CommunityCommentUploadImageModal, {
        confirm: this.onUploadImageConfirmed,
      });
    },
    onUploadImageConfirmed(data) {
      this.attachment = {
        attachment_type: 'image',
        attached_image: data.image,
      };
    },
    loadAttachment: _.debounce(async function (url) {
      this.isAttachmentLoading = true;
      try {
        if (this.cancelSource) {
          this.cancelSource.cancel();
        }
        this.cancelSource = axios.CancelToken.source();
        const fetchedLink = await auth.fetchLink(url, this.cancelSource?.token);
        if (!fetchedLink.title && !fetchedLink.image) return;
        this.attachment = {
          attachment_type: 'embedded_link',
          attached_title: fetchedLink.title,
          attached_description: fetchedLink.description,
          attached_url: fetchedLink.url,
          attached_image: fetchedLink.image,
        };
      } catch (e) {
        console.log(e);
      } finally {
        this.isAttachmentLoading = false;
      }
    }, 300),
    async parseAttachment(text = '', spaceAfter = true) {
      if (this.hasAttachment) return;
      const allTextUrls = parseUrls(text, spaceAfter).filter(
        url => !this.dismissedUrls.includes(url)
      );

      if (allTextUrls.length) {
        this.loadAttachment(allTextUrls[0]);
      }
    },
    removeAttachment() {
      this.dismissedUrls.push(this.attachment.attached_url);
      this.cleanAttachment();
    },
    cleanAttachment() {
      this.attachment = {
        attachment_type: null,
        attached_title: null,
        attached_description: null,
        attached_url: null,
        attached_image: null,
      };
    },
    openRecordingModal() {
      this.$modal.show(AudioRecordingModal, {
        onRecordingAvailable: this.onRecordAudioConfirmed,
      });
    },
    async onRecordAudioConfirmed(inputFile) {
      try {
        this.isAttachmentLoading = true;
        const file = await this.api.uploadFileToS3(inputFile, progress => {
          Vue.set(this.attachment, 'progress', progress);
        });
        this.attachment = {
          attachment_type: 'audio',
          attached_url: file,
        };
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Audio upload failed',
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isAttachmentLoading = false;
      }
    },
  },
  mounted() {
    const parseAttachment = this.parseAttachment;
    this.editor = new Editor({
      onUpdate(event) {
        if (
          event.transaction.getMeta('paste') &&
          event.transaction.steps?.[0]?.slice?.content?.content?.[0]?.text
        ) {
          const text =
            event.transaction.steps?.[0]?.slice?.content?.content?.[0]?.text;
          parseAttachment(text, false);
        } else {
          parseAttachment(event.editor.getText());
        }
      },
      extensions: [
        StarterKit,
        Placeholder,
        CommunityMention.CommunityMention.configure({
          suggestion: {
            items: ({ editor, query }) => this.searchUsers(query),
            render: () => {
              let component;
              let popup;

              return {
                onStart: props => {
                  props.items = props.items || [];
                  component = new VueRenderer(CommunityCommentMentionList, {
                    parent: this,
                    propsData: props,
                  });

                  popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                  });
                },
                onUpdate(props) {
                  component.updateProps(props);

                  popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                  });
                },
                onKeyDown(props) {
                  return component.ref?.onKeyDown(props);
                },
                onExit() {
                  popup[0].destroy();
                  component.destroy();
                },
              };
            },
          },
        }),
        Image,
        Link,
      ],
      content: this.editText || ``,
    });
    this.hashtag = this.initialHashtag || null;
  },
  beforeDestroy() {
    this.editor.destroy();
  },
});
